import { Component, Inject, NgZone, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Driver } from '../../fake.data';

@Component({
  selector: 'crm-driver-dialog',
  templateUrl: './crm-driver-dialog.component.html',
  styleUrls: ['./crm-driver-dialog.component.scss']
})
export class CrmDriverDialogComponent implements OnInit {
  driver: Driver;

  constructor(
    public dialogRef: MatDialogRef<CrmDriverDialogComponent>,
    private ngZone: NgZone,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  save() {}

  public close(): void {
    this.dialogRef.close(false);
  }
}
